import { render, staticRenderFns } from "./VehicleImageComponent.vue?vue&type=template&id=ccee6e3a"
import script from "./VehicleImageComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleImageComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports